export default "__VITE_ASSET__D0AD3rb0__"